<div class="app-component-container" id="logo-carousel">
  <div class="content">
      <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
  </div>
  <app-base-logo-carousel [elemIds]="elementSignals['carousel-config']()"></app-base-logo-carousel>
</div>
